import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { genericFormStyling } from '../../../../styles/common/form.styles';
import { mixinRobotoBold } from '../../../../styles';

export const SellerRfqQueryStyles = css`
  ${MainStyles}
  ${genericFormStyling}

:host {
    display: contents;
  }

  .container-header {
    height: 56px;
    border-bottom: 1px solid var(--border-1);
    margin-bottom: 8px;
    display: flex;
  }

  .container-buttons {
    height: 72px;
    border-top: 1px solid var(--border-1);
    width: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
  }

  .container-title {
    margin: 0;
    line-height: 56px;
    font-size: 18px;
    font-weight: 500;
    white-space: nowrap;
    padding-left: 15px;
    ${mixinRobotoBold};
  }

  .dialog-content {
    width: 100%;
    padding: 12px;
    overflow-y: scroll;
    height: calc(100% - 128px);
  }

  .container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .form-control {
    display: flex;
    flex-direction: column;
  }

  .no-padding-bottom {
    padding-bottom: 0px !important;
  }

  .range-value {
    display: flex;
    gap: 9px;
    width: 100%;
  }

  .minus-sign {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .seller-rfq-query-form {
    display: flex;
    flex-direction: column;
  }

  .center-content {
    justify-content: center;
    padding-right: 16px;
    padding-bottom: 0px;
    padding-top: 8px;
  }

  .custom-size-select {
    min-width: 150px;
  }

  .custom-segmented-item {
    margin: 0px;
    height: 38px;
  }

  zero-button {
    margin-right: 16px;
  }

  cascade-multi-select.fast-listbox {
    width: 100%;
  }
`;
